theme.footerSection = (function(){
  function footer(){
    // Initialize accordion functionality
    const footerWidgetAccordion = function () {
      document.querySelectorAll(".footer__widget_toggle").forEach(function (item) {
        item.addEventListener('click', function () {
          const footerWidget = this.closest('.footer__widget'),
                footerWidgetInner = footerWidget.querySelector('.footer__widget_inner');
                
          // Toggle active class for the clicked widget
          if(footerWidget.classList.contains('active')) {
            footerWidget.classList.remove('active');
            slideUp(footerWidgetInner); // Ensure slideUp is defined
          } else {
            footerWidget.classList.add('active');
            slideDown(footerWidgetInner); // Ensure slideDown is defined
            // Close other open widgets (siblings)
            getSiblings(footerWidget.parentElement).forEach(function (sibling) {
              const siblingWidget = sibling.querySelector('.footer__widget'),
                    siblingWidgetInner = siblingWidget.querySelector('.footer__widget_inner');
              siblingWidget.classList.remove('active');
              slideUp(siblingWidgetInner);
            });
          }
        });
      });
    };

    // Initially apply the accordion effect
    footerWidgetAccordion();

    // Handle window resize for desktop view
    window.addEventListener('resize', function () {
      document.querySelectorAll('.footer__widget').forEach(function (item) {
        if(window.outerWidth >= 768) {
          item.classList.remove('active'); // Reset for large screens
          item.querySelector('.footer__widget_inner').style.display = ''; // Reset inline display style
        }
      });

      // Apply accordion functionality again if needed
      footerWidgetAccordion();
    });
  }

  // Helper function to get sibling elements
  function getSiblings(elem) {
    let siblings = [];
    let sibling = elem.parentNode.firstChild;
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }

  // Helper function for sliding up (hides an element with animation)
  function slideUp(element) {
    element.style.transition = "height 0.3s ease-out, opacity 0.3s ease-out"; 
    element.style.height = '0px';
    element.style.opacity = '0';
  }

  // Helper function for sliding down (shows an element with animation)
  function slideDown(element) {
    element.style.transition = "height 0.3s ease-in, opacity 0.3s ease-in"; 
    element.style.height = element.scrollHeight + 'px'; // Set to scrollHeight to allow full content
    element.style.opacity = '1';
  }

  return footer;
})();
